import { Items } from "tilby-models";

/**
 * Takes the item out of a category list, in place: the showcase holds these arrays, so they have to keep their identity.
 * `Array.prototype.filter` returns a new array and leaves the original untouched.
 */
export const removeItemById = (itemsInCategory: Items[] | undefined, id: number): void => {
    if (!itemsInCategory) {
        return;
    }

    for (let i = itemsInCategory.length - 1; i >= 0; i--) {
        if (itemsInCategory[i].id === id) {
            itemsInCategory.splice(i, 1);
        }
    }
};
